App.filter('getFileNameFromContentDisposition', function () {
    return function (contentDisposition) {
        if (!contentDisposition) {
            return '';
        }
        return contentDisposition.split(';')[1].split('filename')[1].split('=')[1].replaceAll('"', '').trim();
    };
});
